class GsQuickShop {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('form');
    this.variantInput = root.querySelector('input[name="id"]');
    this.addButton = root.querySelector('.gs-quick-shop__trigger');
    this.status = root.querySelector('[data-gs-quick-shop-status]');
    this.optionGroups = [...root.querySelectorAll('[data-gs-option-index]')];
    this.variants = this.readVariants();

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-gs-option-value]')) this.update();
    });

    root.addEventListener('submit', () => {
      if (this.status) this.status.textContent = 'Adding...';
    });

    this.update();
  }

  readVariants() {
    const script = this.root.querySelector('[data-gs-quick-shop-variants]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch {
      return [];
    }
  }

  selectedOptions() {
    return this.optionGroups.map((group) => {
      const checked = group.querySelector('[data-gs-option-value]:checked');
      return checked ? checked.value : null;
    });
  }

  variantOptions(variant) {
    return variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  findVariant(options) {
    return this.variants.find((variant) => {
      const variantOptions = this.variantOptions(variant);
      return options.every((option, index) => option && variantOptions[index] === option);
    });
  }

  updateAvailability() {
    const selected = this.selectedOptions();

    this.optionGroups.forEach((group, groupIndex) => {
      const inputs = [...group.querySelectorAll('[data-gs-option-value]')];

      inputs.forEach((input) => {
        const testOptions = [...selected];
        testOptions[groupIndex] = input.value;

        const possible = this.variants.some((variant) => {
          if (!variant.available) return false;

          const variantOptions = this.variantOptions(variant);
          return testOptions.every((option, index) => !option || variantOptions[index] === option);
        });

        input.disabled = !possible;
        input.closest('.gs-quick-shop__value')?.classList.toggle('is-disabled', !possible);
      });
    });
  }

  update() {
    this.updateAvailability();

    if (!this.optionGroups.length) {
      const firstAvailable = this.variants.find((variant) => variant.available) || this.variants[0];
      if (firstAvailable && this.variantInput) this.variantInput.value = firstAvailable.id;
      if (this.addButton) this.addButton.disabled = !firstAvailable?.available;
      if (this.status) this.status.textContent = firstAvailable?.available ? 'Ready to add' : 'Sold out';
      return;
    }

    const selected = this.selectedOptions();
    const complete = selected.every(Boolean);
    const variant = complete ? this.findVariant(selected) : null;
    const canAdd = Boolean(variant?.available);

    if (this.variantInput && variant) this.variantInput.value = variant.id;
    if (this.addButton) this.addButton.disabled = !canAdd;

    if (!this.status) return;

    if (!complete) {
      this.status.textContent = 'Choose all options';
    } else if (!variant) {
      this.status.textContent = 'Combination unavailable';
    } else if (!variant.available) {
      this.status.textContent = 'Sold out';
    } else {
      this.status.textContent = 'Ready to add';
    }
  }
}

function initGsQuickShop(scope = document) {
  scope.querySelectorAll('[data-gs-quick-shop]:not([data-gs-quick-shop-ready])').forEach((root) => {
    root.dataset.gsQuickShopReady = 'true';
    new GsQuickShop(root);
  });
}

initGsQuickShop();
document.addEventListener('shopify:section:load', (event) => initGsQuickShop(event.target));
